import React, { useEffect, useState } from "react";
import HeroArea from "./HeroArea";
import PopularEventArea from "./PopularEventArea";
import PageLoader from "../../common/PageLoader";
import { sortEventsDesc } from "../../../utils/events";

const HomePage = () => {
  const [events, setEvents] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events?populate[address][populate][0]=city&populate[contact][populate]=*&populate[listImage][populate]=*&populate[detailsImage][populate]=*&populate[thumbnailImage][populate]=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        data?.data?.sort(sortEventsDesc);
        setEvents(data?.data || []);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchEvents();
  }, []);

  const sliderEvents = events.slice(0, 3);

  if (isLoading) {
    return <PageLoader />;
  }

  return (
    <main className="homepage">
      <HeroArea events={sliderEvents} />
      <PopularEventArea events={events} />
    </main>
  );
};

export default HomePage;
